export enum PayBizType {
  /**
   * @zh fastmoss会员
   * @en fastmoss member
   */
  FastMossMember = 1,
  /**
   * @zh fastmoss积分
   * @en fastmoss points
   */
  FastMossPoints = 2,
  /**
   * @zh MossCreator会员
   * @en MossCreator member
   */
  MossCreatorMember = 3,
  /**
   * @zh AdsMoss会员
   * @en AdsMoss member
   */
  AdsMossMember = 4,
  /**
   * @zh YooFinds商品
   * @en YooFinds product
   */
  YooFindsProduct = 5,
  /**
   * @zh 大会门票
   * @en Conference ticket
   */
  ConferenceTicket = 11,
}

export enum PaymentMethod {
  /**
   * @zh 微信(pc)
   * @en Wechat(pc)
   */
  WechatPc = "wechat-pc",
  /**
   * @zh 支付宝(pc)
   * @en Alipay(pc)
   */
  AlipayPc = "alipay-pc",
  /**
   * @zh paypal(pc)
   * @en Paypal(pc)
   */
  PaypalPc = "paypal-pc",
  /**
   * @zh stripe(pc)
   * @en Stripe(pc)
   */
  StripePc = "stripe-pc",
  /**
   * @zh 微信(H5)
   * @en Wechat(H5)
   */
  WechatH5 = "wechat-h5",
  /**
   * @zh 支付宝(H5)
   * @en Alipay(H5)
   */
  AlipayH5 = "alipay-h5",
  /**
   * @zh paypal(H5)
   * @en Paypal(H5)
   */
  PaypalH5 = "paypal-h5",
  /**
   * @zh 微信内部(H5)
   * @en Wechat inside(H5)
   */
  WechatInsideH5 = "wechat-inside-h5",
  /**
   * @zh stripe(H5)
   * @en Stripe(H5)
   */
  StripeH5 = "stripe-h5",
  /**
   * @zh 微信(小程序)
   * @en Wechat(mini program)
   */
  WechatMiniProgram = "wechat-mini-program",

  /**
   * @zh payssion支付
   * @en Payssion
   */
  Payssion = "payssion",
  /**
   * @zh 空中云汇
   * @en Airwallex
   */
  Airwallex = "airwallex",
}

export enum PayChannel {
  /**
   * @zh 微信扫码支付（PC端）
   * @en WeChat QR Code Payment (PC)
   */
  WechatPc = 1,

  /**
   * @zh 支付宝扫码支付（PC端）
   * @en Alipay QR Code Payment (PC)
   */
  AlipayPc = 2,

  /**
   * @zh PayPal 支付（PC端）
   * @en PayPal Payment (PC)
   */
  PaypalPc = 3,

  /**
   * @zh Stripe 支付（PC端）
   * @en Stripe Payment (PC)
   */
  StripePc = 4,

  /**
   * @zh 微信H5支付
   * @en WeChat H5 Payment
   */
  WechatH5 = 5,

  /**
   * @zh 支付宝H5支付
   * @en Alipay H5 Payment
   */
  AlipayH5 = 6,

  /**
   * @zh PayPal H5支付
   * @en PayPal H5 Payment
   */
  PaypalH5 = 7,

  /**
   * @zh 微信内H5支付
   * @en WeChat Inside H5 Payment
   */
  WechatInsideH5 = 8,

  /**
   * @zh 微信小程序支付
   * @en WeChat Mini Program Payment
   */
  WechatMiniProgram = 9,

  /**
   * @zh Stripe H5支付
   * @en Stripe H5 Payment
   */
  StripeH5 = 10,

  /**
   * @zh Dana（印尼）支付
   * @en Dana (ID) Payment
   */
  DanaId = 1001,

  /**
   * @zh Ovo（印尼）支付
   * @en Ovo (ID) Payment
   */
  OvoId = 1002,

  /**
   * @zh 信用卡（印尼）支付
   * @en Credit Card (ID) Payment
   */
  CreditCardId = 1003,

  /**
   * @zh QRIS（印尼）支付
   * @en QRIS (ID) Payment
   */
  QrIsId = 1004,

  /**
   * @zh ShopeePay（印尼）支付
   * @en ShopeePay (ID) Payment
   */
  ShooPeePayId = 1005,

  /**
   * @zh ATM（印尼）支付
   * @en ATM (ID) Payment
   */
  AtmId = 1006,

  /**
   * @zh TrueMoney（泰国）支付
   * @en TrueMoney (TH) Payment
   */
  TrueMoneyTh = 2001,

  /**
   * @zh ShopeePay（泰国）支付
   * @en ShopeePay (TH) Payment
   */
  ShooPeePayTh = 2002,

  /**
   * @zh PromptPay（泰国）支付
   * @en PromptPay (TH) Payment
   */
  PromptPayTh = 2003,

  /**
   * @zh VieTQR（越南）支付
   * @en VieTQR (VN) Payment
   */
  VieTqrVn = 3001,

  /**
   * @zh Boost（马来西亚）支付
   * @en Boost (MY) Payment
   */
  BoostMy = 4001,

  /**
   * @zh Touch 'n Go（马来西亚）支付
   * @en Touch 'n Go (MY) Payment
   */
  TouChnGoMy = 4002,

  /**
   * @zh GrabPay（马来西亚）支付
   * @en GrabPay (MY) Payment
   */
  GrabPayMy = 4003,

  /**
   * @zh FPX（马来西亚）支付
   * @en FPX (MY) Payment
   */
  FpxMy = 4004,

  /**
   * @zh DuitNow（马来西亚）支付
   * @en DuitNow (MY) Payment
   */
  DuItNowMy = 4005,

  /**
   * @zh GCash（菲律宾）支付
   * @en GCash (PH) Payment
   */
  GCashPh = 5001,

  /**
   * @zh GrabPay（菲律宾）支付
   * @en GrabPay (PH) Payment
   */
  GrabPayPh = 5002,

  /**
   * @zh Maya（菲律宾）支付
   * @en Maya (PH) Payment
   */
  MayaPh = 5003,

  /**
   * @zh InstaPay（菲律宾）支付
   * @en InstaPay (PH) Payment
   */
  InsTaPayPh = 5004,

  /**
   * @zh PesoNet（菲律宾）支付
   * @en PesoNet (PH) Payment
   */
  PeSonEtPh = 5005,

  /**
   * @zh 支付宝（中国）支付
   * @en Alipay (CN) Payment
   */
  AlipayCn = 6001,

  /**
   * @zh Airwallex 支付
   * @en Airwallex Payment
   */
  Airwallex = 20001,
}

export enum PayStatus {
  /**
   * @zh 失败
   * @en Failed
   */
  Failed = 0,
  /**
   * @zh 支付成功
   * @en Successful
   */
  Successful = 1,
}
